export const getSubventionRequests = state => state.subventionRequest.subventionRequestsList;
export const getSubventionRequestDetails = state => state.subventionRequest.subventionRequestDetails;
